import { render, staticRenderFns } from "./InventoryPurchaseGroup.vue?vue&type=template&id=e8ca2764&"
import script from "./InventoryPurchaseGroup.vue?vue&type=script&lang=js&"
export * from "./InventoryPurchaseGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports